const a = (o) => {
  const e = new URL(window.location.href);
  Object.entries(o).forEach(([t, r]) => {
    r === void 0 ? e.searchParams.delete(t) : e.searchParams.set(t, r);
  }), window.history.replaceState(null, "", e.toString());
};
export {
  a as updateURL
};
